import { isDefined } from '@aloft/toolkit-shared';
import { Tooltip } from '@aloft/toolkit-sui';

import { ComponentProps } from 'react';

export const MaybeTooltip = ({ children, ...props }: ComponentProps<typeof Tooltip>) => {
  const hasContent = isDefined(props.label);
  return hasContent ? <Tooltip {...props}>{children}</Tooltip> : children;
};
